import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-header-notifications',
    templateUrl: './header-notifications.component.html',
    styleUrls: ['./header-notifications.component.scss'],
    standalone: false
})
export class HeaderNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
